// extracted by mini-css-extract-plugin
module.exports = {"bubble":"Bubble-module--bubble--1ixu6"};